import { observer } from 'mobx-react-lite';
import { HashRouter as Router } from 'react-router-dom';
import { StateContext } from 'state';
import rootState from 'state';
import { ErrorMessage, LoadingPlaceholder } from 'components';
import ModalProvider from 'lib/ModalContext';
import Navigation from './navigation';

window.rootState__ = rootState;

const App = () => {
  return rootState.isInitialized ? (
    rootState.error ? (
      <ErrorMessage
        title="Something went wrong..."
        description={rootState.error}
        actions={[
          {
            onClick: () => window.location.reload(),
            actionTitle: 'Refresh page',
            // reverse: true,
          },
          ...(rootState.isAuthorized
            ? [
                {
                  onClick: () => rootState.authState.logout(),
                  actionTitle: 'Logout',
                  // reverse: true,
                },
              ]
            : []),
        ]}
        action={() => window.location.reload()}
        actionTitle="Refresh page"
      />
    ) : (
      <StateContext.Provider value={rootState}>
        <ModalProvider>
          <Router>
            <Navigation />
          </Router>
        </ModalProvider>
      </StateContext.Provider>
    )
  ) : (
    <LoadingPlaceholder />
  );
};

export default observer(App);
